import { ChangeEvent, FC, useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { Loading, Modal, Table } from '../../../../components';
import { TVeiculoAcessorio, getVehicleAccessories } from '../../../../services';
import { RegistrationPage } from '../../templates';
import { RegistrationEntities, useFilteredItems } from '../../../../utils';
import { TableWrapper } from '../../Registration.styles';
import { useToastStore } from '../../../../stores';

const RegistrationAccessories: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState<boolean>(true);
	const [accessories, setAccessories] = useState<TVeiculoAcessorio[]>([]);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const { filteredItems, filterLoading } = useFilteredItems({
		items: accessories,
		searchTerm,
		status: null,
		filterFn: useCallback((item: TVeiculoAcessorio, searchTerm: string) => {
			let matchesSearchTerm = true;

			if (searchTerm) {
				const matchesDescription = item.veiculoAcessorio
					?.toLowerCase()
					.includes(searchTerm.toLowerCase());

				matchesSearchTerm = matchesDescription;
			}

			return matchesSearchTerm;
		}, []),
	});

	const tableColumns = useMemo(
		() => [
			{ id: 'description', label: 'Descrição' },
			//{ id: 'actions', label: 'Ações' },
		],
		[]
	);

	const rowMapper = useCallback(
		(item: TVeiculoAcessorio) => ({
			description: { value: item.veiculoAcessorio, rawValue: item.veiculoAcessorio },
			/*
			actions: {
				value: (
					<ActionsContainer>
						<Tooltip title='Editar' placement='top' arrow>
							<Link to=''>
								<Button variant='icon' icon={<EditOutlined fontSize='inherit' />} />
							</Link>
						</Tooltip>
						<Tooltip title='Excluir' placement='top' arrow>
							<div>
								<Button
									variant='icon'
									icon={<DeleteOutlined fontSize='inherit' />}
									onClick={() => setOpenDeleteModal(true)}
								/>
							</div>
						</Tooltip>
					</ActionsContainer>
				),
			},
			*/
		}),
		[]
	);

	const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	};

	const handleDelete = () => {};

	const MemoizedTable = useMemo(
		() => <Table paginate columns={tableColumns} rows={filteredItems.map(rowMapper)} />,
		[filteredItems, rowMapper, tableColumns]
	);

	useLayoutEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await getVehicleAccessories();
				const sorted = (response || []).sort((a, b) => {
					if (a.veiculoAcessorio < b.veiculoAcessorio) {
						return -1;
					}
					if (a.veiculoAcessorio > b.veiculoAcessorio) {
						return 1;
					}
					return 0;
				});
				setAccessories(sorted);
			} catch {
				setToast({
					message: 'Erro ao buscar os acessórios!',
					variant: 'error',
				});
			} finally {
				setTimeout(() => setLoading(false), 500);
			}
		};

		fetchData();
	}, [setToast]);

	if (loading) return <Loading fullScreen />;

	return (
		<RegistrationPage
			entity={RegistrationEntities.accessory}
			searchTerm={searchTerm}
			disableNewButton={true}
			onChange={handleSearchChange}
		>
			<>
				<Modal
					open={openDeleteModal}
					onClose={() => setOpenDeleteModal(false)}
					title='Confirmação!'
					primaryButtonText='Sim'
					secondaryButtonText='Não'
					onPrimaryButtonClick={handleDelete}
					onSecondaryButtonClick={() => setOpenDeleteModal(false)}
				>
					Deseja realmente excluir?
				</Modal>
				<TableWrapper>{filterLoading ? <Loading /> : MemoizedTable}</TableWrapper>
			</>
		</RegistrationPage>
	);
};

export default RegistrationAccessories;
